import { Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { icons } from '../shared-asstes/icons'
import { dimens } from '../shared-constants/dimens'
import { colors } from '../shared-constants/colors'
import { fontsWeight } from '../shared-constants/fonts'

export const FullScreenModalContext = React.createContext({
  component: undefined,
  refresh: false,
  eventCach: null,
  setEventCache: () => {},
  setComponent: (component) => {},
  show: () => {},
  hide: () => {},
  title: '',
  setTitle: (title) => {},
  isShow: false,
  setRefresh: () => {},
})

const FullScreenModalProvider = (props) => {
  const [isShow, setShow] = useState(false)
  const [modalComponent, setModalComponent] = useState()
  const [eventCach, setEventCache] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const [title, setTitle] = useState('')
  const [customWidth, setCustomWidth] = useState('100%')
  const show = () => {
    setShow(true)
  }

  const destroyModal = () => {
    setShow(false)
    setModalComponent(null)
  }

  const hide = () => {
    destroyModal()
    setRefresh(!refresh)
    setCustomWidth('100%')
  }

  return (
    <FullScreenModalContext.Provider
      value={{
        eventCach,
        setEventCache,
        setComponent: setModalComponent,
        component: modalComponent,
        hide,
        show,
        refresh,
        title,
        setTitle,
        setWidth: setCustomWidth,
        isShow,
        setRefresh,
      }}
    >
      {props.children}
      <CustomModal
        className='full-screen-modal fit-width'
        onCancel={hide}
        footer={null}
        // width={customWidth}
        keyboard={true}
        centered={true}
        open={isShow}
        closable={true}
        maskClosable={true}
        destroyOnClose={true}
        title={title}
        closeIcon={<img src={icons.CLOSE_BLACK} />}
      >
        {modalComponent}
      </CustomModal>
    </FullScreenModalContext.Provider>
  )
}

export const ModalContextConsumer = FullScreenModalContext.Consumer

export default FullScreenModalProvider

const CustomModal = styled(Modal)`
  .ant-modal-content {
    position: relative;
    min-height: 500px;
  }
  .ant-modal-title {
    padding: ${dimens.SPACING_M} 0 !important;
    border-bottom: 1px solid ${colors.stroke2} !important;
    font-weight: ${fontsWeight.BOLD} !important;
  }
  .ant-modal-header {
    border: 0 !important;
    padding: ${dimens.SPACING_M} !important;
  }
  .ant-modal-body {
    padding-top: 0 !important;
  }

  .ant-modal-close-x {
    padding: ${dimens.SPACING_M};
    margin: auto;
  }
`
